import React, { Component, useDebugValue } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Panel } from "primereact/panel";
import "primeicons/primeicons.css";
import Server from "../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { confirmAlert } from "react-confirm-alert";
import { AutoComplete } from "primereact/autocomplete";
import { Chip } from "primereact/chip";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { InputNumber } from "primereact/inputnumber";
import { SelectButton } from "primereact/selectbutton";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";

class Travel_Set extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.exportXLS = this.exportXLS.bind(this);

    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetTraveler = this.SetTraveler.bind(this);
    this.toast = React.createRef();

    this.state = {
      layout: "list",
      name: "",
      numberOfAdult: 1,
      numberOfBaby: 0,
      typeOfPayment: "cash",
      payed: false,
      numberOfKid: 0,
      getAll: false,
      selectedRoom: [],
      selectedRoom: [],
      group: {},
      hotels: [],
      permition: [],
      allowEdit: true,
      selectedTraveler: {},
      otherHotelsDate: {},
      currentHotelsDate: {},
      CountArr: {
        adult: 1,
        kid: 0,
        baby: 0,
      },
    };
  }

  isMobile() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  componentDidMount() {
    this.isMobile();
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        userId: response.data.authData.userId,
        username: response.data.authData.username,
        loading: 0,
      });
      that.getPermition(response.data.authData.userId);
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  getPermition(userId) {
    let param = {
      token: localStorage.getItem("api_token"),
      userId: userId,
      systemId: this.props.systemId
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      const permition =
        response.data.result[0] && response.data.result[0].permitions["207"]
          ? response.data.result[0].permitions["207"]
          : [];
      that.setState(
        {
          loading: 0,
          permition: permition,
        },
        () => {
          that.getManagerSystemInfo();
        }
      );
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/getPermition", param, SCallBack, ECallBack);
  }
  exportXLS(selectionOnly) {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.state.GridTravelers);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "travelers");
    });
  }
  saveAsExcelFile(buffer, fileName) {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  getManagerSystemInfo() {
    let that = this;
    let param = {
      user_id: this.state.userId,
    };
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
        mySystem:
          response.data.result[0] && response.data.result[0].system[0]
            ? response.data.result[0].system[0]
            : { subSystem: false },
        userSystemIds: response.data.result[0]
          ? response.data.result[0].systemId
          : null,
      });
      that.getSystems();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.getSystems();
    };
    this.Server.send(
      "MainApi/getManagerSystemInfo",
      param,
      SCallBack,
      ECallBack
    );
  }
  getSystems() {
    let that = this;
    let SCallBack = function (response) {
      let systemId = [];
      if (response.data.result) {
        for (let i = 0; i < response.data.result.length; i++) {
          systemId.push({
            value: response.data.result[i]._id,
            name: response.data.result[i].name,
          });
        }
      }
      that.setState({
        systems: systemId,
        managerSystem:
          that.state.mySystem && that.state.mySystem._id
            ? that.state.mySystem._id
            : response.data.result[0]
            ? response.data.result[0]._id
            : null,
      });
      that.getTravelGroups(that.state.getAll);
    };
    let ECallBack = function (error) {
      that.getTravelGroups(that.state.getAll);
    };
    this.Server.send("MainApi/getSystems", {}, SCallBack, ECallBack);
  }
  SetTraveler() {
    let that = this;

    const room = [];

    for (let i = 0; i < that.state.selectedRoom.length; i++) {
      if (that.state.selectedRoom[i].traveler == that.state.travelerId) {
        room.push({
          _id: that.state.selectedRoom[i]._id,
          hotelId: that.state.selectedRoom[i].hotelId,
        });
      }
    }

    const rooms = room;
    if (!this.state.name) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>نام سرپرست نمیتواند خالی باشد</div>,
        life: 8000,
      });
      return;
    }
    if (!this.state.nationalCode) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>کد ملی سرپرست نمیتواند خالی باشد</div>,
        life: 8000,
      });
      return;
    }
    if (!this.state.mobile) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>تلفن همراه سرپرست نمیتواند خالی باشد</div>,
        life: 8000,
      });
      return;
    }
    let numberOfAdult = this.state.numberOfAdult - 1;
    let numberOfKid = this.state.numberOfKid;
    let numberOfBaby = this.state.numberOfBaby;
    let param = {
      token: localStorage.getItem("api_token"),
      groupId: this.state.groupId,
      travelerId: this.state.travelerId,
      rooms: rooms,
      roomsChanged: this.state.roomsChanged,
      params: {
        name: this.state.name,
        family: this.state.family,
        lname: this.state.lname,
        lfamily: this.state.lfamily,
        birthDate: this.state.birthDate
          ? this.state.birthDate.local("en").format("YYYY/M/D")
          : "",
        birthDate_en: this.state.birthDate
          ? this.state.birthDate.local("en").format("YYYY/M/D")
          : "",
        passportNum: this.state.passportNum,
        passportDate: this.state.passportDate,
        desc: this.state.desc,
        username: this.state.username,
        typeOfPayment: this.state.payed ? this.state.typeOfPayment : "cash",
        payed: this.state.payed,
        userId: this.state.userId,
        nationalCode: this.state.nationalCode,
        mobile: that.state.mobile,
        installmentPay: this.state.installmentPay
          ? this.state.installmentPay.toString().replace(/,/g, "")
          : "",
        prePay: this.state.prePay
          ? this.state.prePay.toString().replace(/,/g, "")
          : "",
      },
    };
    const others = [];
    let index = 0;
    let number = 1;
    for (let i = 0; i < this.state.CountArr.adult - 1; i++) {
      if (this.state["name_adult_" + i] && !this.state["disabled_adult_" + i]) {
        others[index] = {
          nationalCode: this.state["nationalCode_adult_" + i],
          name: this.state["name_adult_" + i],
          family: this.state["family_adult_" + i],
          lname: this.state["lname_adult_" + i],
          lfamily: this.state["lfamily_adult_" + i],
          birthDate: this.state["birthDate_adult_" + i]
            ? this.state["birthDate_adult_" + i].local("en").format("YYYY/M/D")
            : "",
          birthDate_en: this.state["birthDate_adult_" + i]
            ? this.state["birthDate_adult_" + i].local("en").format("YYYY/M/D")
            : "",
          passportNum: this.state["passportNum_adult_" + i],
          passportDate: this.state["passportDate_adult_" + i],
          type: "adult",
        };
        index++;
        number++;
      } else if (this.state["disabled_adult_" + i]) {
        numberOfAdult--;
      }
    }
    for (let i = 0; i < this.state.CountArr.kid; i++) {
      if (this.state["name_kid_" + i] && !this.state["disabled_kid_" + i]) {
        others[index] = {
          nationalCode: this.state["nationalCode_kid_" + i],
          name: this.state["name_kid_" + i],
          family: this.state["family_kid_" + i],
          lname: this.state["lname_kid_" + i],
          lfamily: this.state["lfamily_kid_" + i],
          birthDate: this.state["birthDate_kid_" + i]
            ? this.state["birthDate_kid_" + i].local("en").format("YYYY/M/D")
            : "",
          birthDate_en: this.state["birthDate_kid_" + i]
            ? this.state["birthDate_kid_" + i].local("en").format("YYYY/M/D")
            : "",
          passportNum: this.state["passportNum_kid_" + i],
          passportDate: this.state["passportDate_kid_" + i],
          type: "kid",
        };
        number++;
        index++;
      } else if (this.state["disabled_kid_" + i]) {
        numberOfKid--;
      }
    }
    for (let i = 0; i < this.state.CountArr.baby; i++) {
      if (this.state["name_baby_" + i] && !this.state["disabled_baby_" + i]) {
        others[index] = {
          nationalCode: this.state["nationalCode_baby_" + i],
          name: this.state["name_baby_" + i],
          family: this.state["family_baby_" + i],
          lname: this.state["lname_baby_" + i],
          lfamily: this.state["lfamily_baby_" + i],
          birthDate: this.state["birthDate_baby_" + i]
            ? this.state["birthDate_baby_" + i].local("en").format("YYYY/M/D")
            : "",
          birthDate_en: this.state["birthDate_baby_" + i]
            ? this.state["birthDate_baby_" + i].local("en").format("YYYY/M/D")
            : "",
          passportNum: this.state["passportNum_baby_" + i],
          passportDate: this.state["passportDate_baby_" + i],
          type: "baby",
        };
        index++;
      } else if (this.state["disabled_baby_" + i]) {
        numberOfBaby--;
      }
    }

    param["changeFromCapacity"] = !this.state.travelerId
      ? -number
      : this.state.oldNumber - number;
    param.params["others"] = others;
    param.params["numberOfKid"] = numberOfKid;
    param.params["numberOfBaby"] = numberOfBaby;
    param.params["numberOfAdult"] = numberOfAdult;
    param.params["number"] = number;

    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      if (response.data.error) {
        that.toast.current.show({
          severity: "error",
          summary: <div>{response.data.message}</div>,
          life: 8000,
        });
      } else {
        that.getTraveler(that.state.groupId, false);
        that.resetForm();
        that.toast.current.show({
          severity: "success",
          summary: <div>اطلاعات مسافر ثبت شد</div>,
          life: 8000,
        });
      }
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: <div>عملیات انجام نشد</div>,
        life: 8000,
      });
    };
    this.Server.send("CompanyApi/setTraveler", param, SCallBack, ECallBack);
  }
  resetForm(NoResetTraveler) {
    let others = [{}];

    for (let i = 0; i < this.state.CountArr.adult; i++) {
      others["name_adult_" + i] = "";
      others["family_adult_" + i] = "";
      others["lname_adult_" + i] = "";
      others["lfamily_adult_" + i] = "";
      others["birthDate_adult_" + i] = moment();
      others["passportNum_adult_" + i] = "";
      others["passportDate_adult_" + i] = "";
      others["nationalCode_adult_" + i] = "";
      others["disabled_adult_" + i] = false;
    }
    for (let i = 0; i < this.state.CountArr.kid; i++) {
      others["name_kid_" + i] = "";
      others["family_kid_" + i] = "";
      others["lname_kid_" + i] = "";
      others["lfamily_kid_" + i] = "";
      others["birthDate_kid_" + i] = moment();
      others["passportNum_kid_" + i] = "";
      others["passportDate_kid_" + i] = "";
      others["nationalCode_kid_" + i] = "";
      others["disabled_kid_" + i] = false;
    }
    for (let i = 0; i < this.state.CountArr.baby; i++) {
      others["name_baby_" + i] = "";
      others["family_baby_" + i] = "";
      others["lname_baby_" + i] = "";
      others["lfamily_baby_" + i] = "";
      others["birthDate_baby_" + i] = moment();
      others["passportNum_baby_" + i] = "";
      others["passportDate_baby_" + i] = "";
      others["nationalCode_baby_" + i] = "";
      others["disabled_baby_" + i] = false;
    }
    const selectedRoom = this.state.selectedRoom;
    for (let i = 0; i < this.state.selectedRoom.length; i++) {
      selectedRoom[i].changed = false;
    }

    const state = {
      loading: 0,
      selectedRoom: selectedRoom,
      nationalCode: "",
      desc: "",
      mobile: "",
      prePay: "",
      installmentPay: "",
      name: "",
      lname: "",
      family: "",
      lfamily: "",
      birthDate: moment(),
      passportNum: "",
      passportDate: "",
      numberOfAdult: 1,
      numberOfBaby: 0,
      numberOfKid: 0,
      oldNumber: 1,
      allowEdit: true,
      CountArr: {
        adult: 1,
        kid: 0,
        baby: 0,
      },
      roomsChanged: false,
      ...others,
    };
    if (!NoResetTraveler) {
      state["travelerId"] = null;
    }
    this.setState(state);
  }

  CreateForm() {
    this.setState({
      visibleManageField: true,
      groupId: null,
      allowEdit: true,
    });
  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      groupId: null,
      travelerId: null,
    });
    this.getTravelGroups(this.state.getAll);
  }
  getHotels(hotels) {
    let that = this;
    const list = [];
    if (hotels && Array.isArray(hotels)) {
      for (let i = 0; i < hotels.length; i++) {
        list[i] = hotels[i]._id;
      }
    }
    let param = {
      token: localStorage.getItem("api_token"),
      _ids: list,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      const hotels = response.data.result; /*
      const hotelDates = that.state.hotelDates||[];
      for(let i=0;i<hotelDates.length;i++){
        hotels.map((item)=>{
          if(hotelDates[i].hotel_id == item._id)
          item.hotelDates = hotelDates[i];
        })
      }*/
      that.setState({
        loading: 0,
        hotels: hotels,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("CompanyApi/getHotels", param, SCallBack, ECallBack);
  }

  getHotelReserved(hotelId) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      hotelId: hotelId,
      groupId: this.state.groupId,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      let otherHotelsDate = [];
      let currentHotelsDate = [];

      let dates = [];
      for (let i = 0; i < that.state.hotelDates.length; i++) {
        if (that.state.hotelDates[i].hotel_id == hotelId) {
          dates = dates.concat(that.state.hotelDates[i].dates);
        }
      }
      currentHotelsDate = dates;

      let groups = [];
      for (let i = 0; i < response.data.result.length; i++) {
        if (response.data.result[i].hotel_id == hotelId) {
          for (let j = 0; j < currentHotelsDate.length; j++) {
            for (let k = 0; k < response.data.result[i].dates.length; k++) {
              if (
                currentHotelsDate[j].day ==
                  response.data.result[i].dates[k].day &&
                currentHotelsDate[j].mounth ==
                  response.data.result[i].dates[k].mounth &&
                currentHotelsDate[j].year ==
                  response.data.result[i].dates[k].year
              ) {
                groups.push(response.data.result[i].groupId);
              }
            }
          }
        }
      }
      that.setState({
        loading: 0,
      });
      that.getTravelersReservedRooms(groups, hotelId);
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send(
      "CompanyApi/getHotelReserved",
      param,
      SCallBack,
      ECallBack
    );
  }

  getTravelersReservedRooms(groupIds, hotelId) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      groupIds: groupIds,
    };
    this.setState({
      loading: 1,
    });
    let selectedRoom = [];
    let SCallBack = function (response) {
      let others = [];
      for (let i = 0; i < that.state.hotels.length; i++) {
        for (let j = 0; j < that.state.hotels[i].numberOfRoom; j++) {
          for (let k = 0; k < response.data.result.length; k++) {
            if (
              that.state.hotels[i].rooms[j]._id ==
                response.data.result[k].hotel_room_id &&
              hotelId == that.state.hotels[i]._id
            ) {
              selectedRoom.push({
                _id: response.data.result[k].hotel_room_id,
                traveler: response.data.result[k].travelerId,
                hotelId: hotelId,
              });
            }
          }
        }
      }
      selectedRoom = selectedRoom.concat(that.state.selectedRoom);
      const uniqueIds = [];
      const uniqSelectedRoom = selectedRoom.filter((element) => {
        const isDuplicate = uniqueIds.includes(element._id);
        if (!isDuplicate) {
          uniqueIds.push(element._id);
          return true;
        }
        return false;
      });
      that.setState({
        loading: 0,
        selectedRoom: uniqSelectedRoom,
        ...others,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };

    this.Server.send(
      "CompanyApi/getTravelersReservedRooms",
      param,
      SCallBack,
      ECallBack
    );
  }
  getTraveler(groupId, resetSelectedRooms) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      groupId: groupId,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      let res = response.data.result;
      let rooms = response.data.rooms;
      let hotelDates = response.data.hotelDates;

      let others = [];
      let selectedRoom = [];
      res.map((item) => {
        item.inserted = item.inserted[0] ? item.inserted[0].name : "-";
        item.updated = item.updated[0] ? item.updated[0].name : "-";
      });
      if (resetSelectedRooms) {
        rooms.map((item) => {
          selectedRoom.push({
            _id: item.hotel_room_id,
            traveler: item.travelerId,
            hotelId: item.hotelId,
          });
        });
      }
      /*

      if (!that.state.permition[0]) {
        res = res.filter((item) => {
          return (
            !item.insertUsername ||
            item.insertUsername == that.state.username ||
            item.updateUsername == that.state.username
          );
        });
      }*/
      const state = {
        GridTravelers: res,
        hotelDates: hotelDates,
        ...others,
        loading: 0,
      };
      if (resetSelectedRooms) {
        state["selectedRoom"] = selectedRoom;
      }else{
        if(res[0]){
          state["group"] = res[0].group[0]
        }
      }
      that.setState(state,()=>{
        if(!resetSelectedRooms && !res[0]){
          that.onHideFormsDialog();
        }
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("CompanyApi/getTravelers", param, SCallBack, ECallBack);
  }
  delField(rowData) {
    if (
      !this.state.permition.some((item) => {
        return item == 2;
      })
    ) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>شما دسترسی حذف مسافر را ندارید</div>,
        life: 8000,
      });
      return;
    }
    this.setState({
      visibleManageField: false,
    });
    confirmAlert({
      title: <span className="yekan">حذف مسافر</span>,
      message: (
        <span className="yekan"> آیا از حذف {rowData.name} مطمئنید </span>
      ),
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              travelerId: rowData._id,
              groupId: that.state.groupId,
              system: that.state.system,
              changeFromCapacity: rowData.number,
              del: 1,
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0,
              });
              that.getTraveler(that.state.groupId, false);
              that.resetForm();
              that.toast.current.show({
                severity: "success",
                summary: <div>اطلاعات مسافر حذف شد</div>,
                life: 8000,
              });
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0,
              });
              that.toast.current.show({
                severity: "error",
                summary: <div>عملیات انجام نشد</div>,
                life: 8000,
              });
            };
            this.Server.send(
              "CompanyApi/SetTraveler",
              param,
              SCallBack,
              ECallBack
            );
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }
  getTravelGroups(getAll) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      category: "atabat",
      getAll: getAll,
      userSystemIds: this.state.userSystemIds,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        GridDataFields: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("CompanyApi/getTravelGroups", param, SCallBack, ECallBack);
  }
  render() {
    let hotelIndex = 0;
    const delTemplate = (rowData, props) => {
      return (
        <i
          className="fa fa-times"
          style={{ cursor: "pointer" }}
          aria-hidden="true"
          onClick={() => this.delField(rowData)}
        ></i>
      );
    };
    const nameTemplate = (rowData, props) => {
      return rowData.family ? (
        <span>
          <span>{rowData.name}</span>
          <span> </span>
          <span>{rowData.family}</span>
        </span>
      ) : (
        <span>{rowData.name}</span>
      );
    };

    const typeTemplate = (rowData, props) => {
      if (rowData.type == "air") {
        return (
          <span>
            <i className="fas fa-plane" style={{ color: "green" }}></i>
          </span>
        );
      } else {
        return (
          <span>
            <i className="fas fa-bus" style={{ color: "green" }}></i>
          </span>
        );
      }
    };
    const amountTemplate = (rowData, props) => {
      if (rowData.price && rowData.price.adult) {
        return (
          <span>
            {rowData.price.adult
              .toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        );
      } else {
        return "-";
      }
    };

    return (
      <div style={{ direction: "rtl" }}>
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center">
          <div className="col-12" style={{ background: "#fff" }}>
            <div>
              <div>
                <div className="group">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <Checkbox
                      inputId="active"
                      value={this.state.getAll}
                      checked={this.state.getAll}
                      onChange={(e) => {
                        this.setState({ getAll: e.checked });
                        this.getTravelGroups(e.checked);
                      }}
                    ></Checkbox>
                    <label
                      htmlFor="active"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                      نمایش همه گروهها
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <Panel
              header="لیست گروهها"
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <DataTable
                responsive
                value={this.state.GridDataFields}
                selectionMode="single"
                onSelectionChange={(e) => {
                  const value = e.value;
                  this.setState({
                    group: value,
                    groupId: value._id,
                    visibleManageField: true,
                  });
                  this.getTraveler(value._id, true);
                  this.getHotels(value.hotels);

                  this.resetForm();
                }}
              >
                <Column
                  field="fromDate"
                  header="تاریخ حرکت"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="type"
                  body={typeTemplate}
                  header="نوع حرکت"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="desc"
                  header="توضیحات"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />

                <Column
                  field="originalCapacity"
                  header="ظرفیت کل"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="capacity"
                  header="ظرفیت باقیمانده"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />

                <Column
                  field="Time"
                  header="مدت"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="Time"
                  body={amountTemplate}
                  header="مبلغ"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
          </div>
        </div>

        <Dialog
          header={this.state.groupId ? "اصلاح" : "ساخت ردیف جدید"}
          visible={this.state.visibleManageField}
          minY={70}
          onHide={this.onHideFormsDialog}
          maximizable={true}
          maximized={true}
        >
          <Toast
            ref={this.toast}
            position="top-left"
            style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
          />
          <form
            onSubmit={(event) => {
              this.SetTraveler();
              event.preventDefault();
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                flexDirection: "row",
                alignItems: "baseline",
              }}
              className="row"
            >
              <div className="col-md-2 col-12" style={{ textAlign: "right" }}>
                {this.state.group && this.state.group.type == "air" ? (
                  <span>
                    <i className="fas fa-plane" style={{ color: "green" }}></i>
                  </span>
                ) : (
                  <span>
                    <i className="fas fa-bus" style={{ color: "green" }}></i>
                  </span>
                )}
              </div>
              <div className="col-md-3 col-12" style={{ textAlign: "right" }}>
                <h4> تاریخ حرکت : {this.state.group.fromDate}</h4>
              </div>
              <div className="col-md-3 col-12" style={{ textAlign: "right" }}>
                <h4> ظرفیت کل : {this.state.group.originalCapacity}</h4>
              </div>
              <div className="col-md-3 col-12" style={{ textAlign: "right" }}>
                <h4>
                  {" "}
                  ظرفیت باقیمانده :{" "}
                  <span style={{ color: "green" }}>
                    {this.state.group.capacity}
                  </span>
                </h4>
              </div>
            </div>
            <button
              type="button"
              onClick={() => this.exportXLS(false)}
              className="btn btn-primary yekan"
              data-pr-tooltip="XLS"
              style={{ display: "none" }}
            >
              دریافت خروجی اکسل
            </button>
            <Panel
              header="لیست مسافران"
              style={{
                textAlign: "right",
                fontFamily: "yekan",
                marginBottom: 30,
              }}
              toggleable={true}
              collapsed={true}
            >
              <DataTable
                responsive
                value={this.state.GridTravelers}
                selectionMode="single"
                selection={this.state.selectedTraveler}
                onSelectionChange={(e) => {
                  this.resetForm(true);
                  setTimeout(() => {
                    const value = e.value;
                    let countAdult = 0;
                    let countKid = 0;
                    let countBaby = 0;
                    let others = [];
                    for (let i = 0; i < value.others.length; i++) {
                      if (value.others[i].type == "adult") {
                        others["name_adult_" + countAdult] =
                          value.others[i].name || "";
                        others["family_adult_" + countAdult] =
                          value.others[i].family || "";
                        others["lname_adult_" + countAdult] =
                          value.others[i].lname || "";
                        others["lfamily_adult_" + countAdult] =
                          value.others[i].lfamily || "";
                        others["birthDate_adult_" + countAdult] =
                          value.others[i].birthDate || ""
                            ? moment(value.others[i].birthDate, "YYYY/M/D")
                            : moment();
                        others["passportNum_adult_" + countAdult] =
                          value.others[i].passportNum || "";
                        others["passportDate_adult_" + countAdult] =
                          value.others[i].passportDate || "";
                        others["nationalCode_adult_" + countAdult] =
                          value.others[i].nationalCode || "";
                        countAdult++;
                      }
                      if (value.others[i].type == "kid") {
                        others["name_kid_" + countKid] =
                          value.others[i].name || "";
                        others["family_kid_" + countKid] =
                          value.others[i].family || "";
                        others["lname_kid_" + countKid] =
                          value.others[i].lname || "";
                        others["lfamily_kid_" + countKid] =
                          value.others[i].lfamily || "";
                        others["birthDate_kid_" + countKid] = value.others[i]
                          .birthDate
                          ? moment(value.others[i].birthDate, "YYYY/M/D")
                          : moment();
                        others["passportNum_kid_" + countKid] =
                          value.others[i].passportNum || "";
                        others["passportDate_kid_" + countKid] =
                          value.others[i].passportDate || "";
                        others["nationalCode_kid_" + countKid] =
                          value.others[i].nationalCode || "";
                        countKid++;
                      }
                      if (value.others[i].type == "baby") {
                        others["name_baby_" + countBaby] =
                          value.others[i].name || "";
                        others["family_baby_" + countBaby] =
                          value.others[i].family || "";
                        others["lname_baby_" + countBaby] =
                          value.others[i].lname || "";
                        others["lfamily_baby_" + countBaby] =
                          value.others[i].lfamily || "";
                        others["birthDate_baby_" + countBaby] = value.others[i]
                          .birthDate
                          ? moment(value.others[i].birthDate, "YYYY/M/D")
                          : moment();
                        others["passportNum_baby_" + countBaby] =
                          value.others[i].passportNum || "";
                        others["passportDate_baby_" + countBaby] =
                          value.others[i].passportDate || "";
                        others["nationalCode_baby_" + countBaby] =
                          value.others[i].nationalCode || "";
                        countBaby++;
                      }
                    }
                    this.setState({
                      CountArr: {
                        adult: countAdult + 1,
                        kid: countKid,
                        baby: countBaby,
                      },
                      travelerId: value._id,
                      nationalCode: value.nationalCode || "",
                      numberOfAdult: value.numberOfAdult + 1,
                      numberOfBaby: value.numberOfBaby,
                      numberOfKid: value.numberOfKid,
                      name: value.name || "",
                      family: value.family || "",
                      lname: value.lname || "",
                      lfamily: value.lfamily || "",
                      birthDate: value.birthDate
                        ? moment(value.birthDate, "YYYY/M/D")
                        : moment(),
                      passportDate: value.passportDate || "",
                      passportNum: value.passportNum || "",
                      mobile: value.mobile || "",
                      installmentPay: value.installmentPay
                        ? value.installmentPay
                            .replace(/,/g, "")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "",
                      prePay: value.prePay
                        ? value.prePay
                            .replace(/,/g, "")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "",
                      oldNumber: value.number/* - value.numberOfBaby*/,
                      desc: value.desc || "",
                      typeOfPayment: value.typeOfPayment || "cash",
                      payed: value.payed,
                      visibleManageField: true,
                      allowEdit:
                        this.state.permition.some((item) => {
                          return item == 1;
                        }) ||
                        !value.username ||
                        value.username == this.state.username,
                      inserted: value.inserted,
                      ...others,
                    });
                    this.toast.current.clear();
                    if (
                      value.username &&
                      value.username != this.state.username &&
                      !this.state.permition.some((item) => {
                        return item == 1;
                      })
                    ) {
                      this.toast.current.show({
                        severity: "warn",
                        summary: (
                          <div>
                            به دلیل ثبت اطلاعات مسافر جاری توسط کاربر دیگر امکان
                            ویرایش ندارید
                          </div>
                        ),
                        life: 5000,
                      });
                    }
                  }, 0);
                }}
                className="mb-4"
              >
                <Column
                  field="name"
                  header="نام سرپرست"
                  body={nameTemplate}
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="mobile"
                  header="تلفن همراه سرپرست"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="number"
                  header="تعداد"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="nationalCode"
                  header="کد ملی"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="inserted"
                  header="ثبت کننده"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="updated"
                  header="ویرایش کننده"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="del"
                  header="حذف"
                  className="irsans"
                  body={delTemplate}
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
            <Panel
              header={`مشخصات مسافران ${
                this.state.travelerId && this.state.inserted
                  ? `(ثبت شده توسط : ${this.state.inserted})`
                  : ""
              }`}
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <div>
                <div className="row mb-3">
                  {this.state.group.price &&
                    this.state.group.price.adult != "0" && (
                      <div class="col-lg-3 col-12">
                        <div
                          style={{
                            textAlign: "right",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label>
                            <Tag
                              severity="success"
                              value="تعداد بزرگسال"
                              className="mb-2"
                            ></Tag>
                            <span style={{ color: "red" }}>
                              {" "}
                              (قیمت هر نفر{" "}
                              {this.state.group.price
                                ? this.state.group.price.adult
                                    .toString()
                                    .replace(/,/g, "")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""}{" "}
                              تومان){" "}
                            </span>
                          </label>
                          <InputNumber
                            value={this.state.numberOfAdult}
                            style={{ direction: "ltr" }}
                            inputStyle={{
                              borderRadius: 0,
                              padding: 0,
                              textAlign: "center",
                              fontSize: 20,
                            }}
                            mode="decimal"
                            showButtons
                            onValueChange={(e) => {
                              let CountArr = this.state.CountArr;
                              CountArr["adult"] = e.value;
                              this.setState({
                                numberOfAdult: e.value,
                                CountArr: CountArr,
                              });
                            }}
                            min={1}
                            max={1000}
                          />
                        </div>
                      </div>
                    )}
                  {this.state.group.price &&
                    this.state.group.price.kid != "0" && (
                      <div class="col-lg-3 col-12 mt-md-0 mt-2">
                        <div
                          style={{
                            textAlign: "right",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label>
                            <Tag
                              severity="info"
                              value="تعداد کودک"
                              className="mb-2"
                            ></Tag>
                            <span style={{ color: "red" }}>
                              {" "}
                              (قیمت هر نفر{" "}
                              {this.state.group.price
                                ? this.state.group.price.kid
                                    .toString()
                                    .replace(/,/g, "")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""}{" "}
                              تومان){" "}
                            </span>
                          </label>
                          <InputNumber
                            value={this.state.numberOfKid}
                            style={{ direction: "ltr" }}
                            inputStyle={{
                              borderRadius: 0,
                              padding: 0,
                              textAlign: "center",
                              fontSize: 20,
                            }}
                            mode="decimal"
                            showButtons
                            onValueChange={(e) => {
                              let CountArr = this.state.CountArr;
                              CountArr["kid"] = e.value;
                              this.setState({
                                numberOfKid: e.value,
                                CountArr: CountArr,
                              });
                            }}
                            min={0}
                            max={1000}
                          />
                        </div>
                      </div>
                    )}
                  {this.state.group.price &&
                    this.state.group.price.baby != "0" && (
                      <div class="col-lg-3 col-12 mt-md-0 mt-2">
                        <div
                          style={{
                            textAlign: "right",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label>
                            <Tag
                              severity="warning"
                              value="تعداد نوزاد"
                              className="mb-2"
                            ></Tag>
                            <span style={{ color: "red" }}>
                              {" "}
                              (قیمت هر نفر{" "}
                              {this.state.group.price
                                ? this.state.group.price.baby
                                    .toString()
                                    .replace(/,/g, "")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""}{" "}
                              تومان){" "}
                            </span>
                          </label>
                          <InputNumber
                            value={this.state.numberOfBaby}
                            style={{ direction: "ltr" }}
                            inputStyle={{
                              borderRadius: 0,
                              padding: 0,
                              textAlign: "center",
                              fontSize: 20,
                            }}
                            mode="decimal"
                            showButtons
                            onValueChange={(e) => {
                              let CountArr = this.state.CountArr;
                              CountArr["baby"] = e.value;
                              this.setState({
                                numberOfBaby: e.value,
                                CountArr: CountArr,
                              });
                            }}
                            min={0}
                            max={1000}
                          />
                        </div>
                      </div>
                    )}
                </div>
                <Card className="mt-3">
                  <div
                    style={{
                      alignItems: "baseline",
                      display: this.state.isMobile ? "none" : "flex",
                    }}
                    className="mt-3"
                  >
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>نام فارسی</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>نام خانوادگی فارسی</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>نام لاتین</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>نام خانوادگی لاتین</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>کد ملی</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>تاریخ تولد</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>شماره گذرنامه</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    >
                      <label>تاریخ انقضا گذرنامه</label>
                    </div>
                    <div
                      style={{ width: 150, marginLeft: 8, textAlign: "center" }}
                    ></div>
                  </div>
                  <div
                    style={{
                      alignItems: "baseline",
                      display: "flex",
                      flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                    }}
                    className="p-message p-message-success"
                  >
                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          type="text"
                          placeholder={this.state.isMobile ? "نام فارسی" : ""}
                          value={this.state.name}
                          name="name"
                          onChange={(event) => {
                            this.setState({ name: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                      </div>
                    </div>

                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          placeholder={
                            this.state.isMobile ? "نام خانوادگی فارسی" : ""
                          }
                          type="text"
                          value={this.state.family}
                          name="name"
                          onChange={(event) => {
                            this.setState({ family: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                      </div>
                    </div>
                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          placeholder={this.state.isMobile ? "نام لاتین" : ""}
                          type="text"
                          value={this.state.lname}
                          name="name"
                          onChange={(event) => {
                            this.setState({ lname: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                      </div>
                    </div>
                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          placeholder={
                            this.state.isMobile ? "نام خانوادگی لاتین" : ""
                          }
                          type="text"
                          value={this.state.lfamily}
                          name="name"
                          onChange={(event) => {
                            this.setState({ lfamily: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                      </div>
                    </div>
                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          placeholder={this.state.isMobile ? "کد ملی" : ""}
                          type="text"
                          value={this.state.nationalCode}
                          name="name"
                          onChange={(event) => {
                            this.setState({ nationalCode: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                      </div>
                    </div>
                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <DatePicker
                          onChange={(value) =>
                            this.setState({ birthDate: value })
                          }
                          value={this.state.birthDate}
                          isGregorian={true}
                          timePicker={false}
                          placeholder="تاریخ تولد"
                          persianDigits={false}
                        />
                      </div>
                    </div>
                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          placeholder={
                            this.state.isMobile ? "شماره گذرنامه" : ""
                          }
                          type="text"
                          value={this.state.passportNum}
                          name="name"
                          onChange={(event) => {
                            this.setState({ passportNum: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                      </div>
                    </div>
                    <div style={{ width: 150, marginLeft: 8 }}>
                      <div style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          type="text"
                          placeholder={
                            this.state.isMobile ? "تاریخ انقضا گذرنامه" : ""
                          }
                          value={this.state.passportDate}
                          name="name"
                          onChange={(event) => {
                            this.setState({ passportDate: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                      </div>
                    </div>
                    <div style={{ width: 150, marginLeft: 8 }}></div>
                  </div>
                  {Array.from(
                    Array(parseInt(this.state.CountArr.adult - 1)).keys()
                  ).map((item, index) => {
                    return (
                      <div
                        style={{
                          alignItems: "baseline",
                          display: "flex",
                          flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                        }}
                        className="mt-2 p-message p-message-success"
                      >
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              placeholder={
                                this.state.isMobile ? "نام فارسی" : ""
                              }
                              disabled={this.state["disabled_adult_" + index]}
                              type="text"
                              id={"name_adult_" + index}
                              name={"name_adult_" + index}
                              value={this.state["name_adult_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["name_adult_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              placeholder={
                                this.state.isMobile ? "نام خانوادگی فارسی" : ""
                              }
                              disabled={this.state["disabled_adult_" + index]}
                              type="text"
                              id={"family_adult_" + index}
                              name={"family_adult_" + index}
                              value={this.state["family_adult_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["family_adult_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              placeholder={
                                this.state.isMobile ? "نام لاتین" : ""
                              }
                              disabled={this.state["disabled_adult_" + index]}
                              type="text"
                              id={"lname_adult_" + index}
                              name={"lname_adult_" + index}
                              value={this.state["lname_adult_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["lname_adult_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_adult_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام خانوادگی لاتین" : ""
                              }
                              type="text"
                              id={"lfamily_adult_" + index}
                              name={"lfamily_adult_" + index}
                              value={this.state["lfamily_adult_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["lfamily_adult_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_adult_" + index]}
                              type="text"
                              id={"nationalCode_adult_" + index}
                              placeholder={this.state.isMobile ? "کد ملی" : ""}
                              name={"nationalCode_adult_" + index}
                              value={this.state["nationalCode_adult_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["nationalCode_adult_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <DatePicker
                              onChange={(value) =>
                                this.setState({
                                  ["birthDate_adult_" + index]: value,
                                })
                              }
                              value={this.state["birthDate_adult_" + index]}
                              disabled={this.state["disabled_adult_" + index]}
                              isGregorian={true}
                              timePicker={false}
                              placeholder="تاریخ تولد"
                              persianDigits={false}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_adult_" + index]}
                              type="text"
                              placeholder={
                                this.state.isMobile ? "شماره گذرنامه" : ""
                              }
                              id={"passportNum_adult_" + index}
                              name={"passportNum_adult_" + index}
                              value={this.state["passportNum_adult_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["passportNum_adult_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_adult_" + index]}
                              type="text"
                              id={"passportDate_adult_" + index}
                              name={"passportDate_adult_" + index}
                              value={this.state["passportDate_adult_" + index]}
                              placeholder={
                                this.state.isMobile ? "تاریخ انقضا گذرنامه" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["passportDate_adult_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div
                            style={{
                              textAlign: "right",
                              display: "flex",
                              height: "100%",
                              marginTop: 10,
                              maxWidth: 350,
                            }}
                          >
                            <i
                              className="fa fa-ban"
                              style={{ cursor: "pointer", color: "red" }}
                              aria-hidden="true"
                              onClick={(event) => {
                                if (
                                  !this.state.permition.some((item) => {
                                    return item == 2;
                                  })
                                ) {
                                  this.toast.current.show({
                                    severity: "warn",
                                    summary: (
                                      <div>شما دسترسی حذف مسافر را ندارید</div>
                                    ),
                                    life: 8000,
                                  });
                                  return;
                                }
                                const p = {};
                                p["disabled_adult_" + index] =
                                  !this.state["disabled_adult_" + index];
                                this.setState({
                                  ...p,
                                });
                              }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {Array.from(
                    Array(parseInt(this.state.CountArr.kid)).keys()
                  ).map((item, index) => {
                    return (
                      <div
                        style={{
                          alignItems: "baseline",
                          display: "flex",
                          flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                        }}
                        className="mt-2 p-message p-message-info"
                      >
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_kid_" + index]}
                              type="text"
                              id={"name_kid_" + index}
                              placeholder={
                                this.state.isMobile ? "نام فارسی" : ""
                              }
                              name={"name_kid_" + index}
                              value={this.state["name_kid_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["name_kid_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_kid_" + index]}
                              type="text"
                              id={"family_kid_" + index}
                              name={"family_kid_" + index}
                              value={this.state["family_kid_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام خانوادگی فارسی" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["family_kid_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_kid_" + index]}
                              type="text"
                              id={"lname_kid_" + index}
                              name={"lname_kid_" + index}
                              value={this.state["lname_kid_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام لاتین" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["lname_kid_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_kid_" + index]}
                              type="text"
                              id={"lfamily_kid_" + index}
                              name={"lfamily_kid_" + index}
                              value={this.state["lfamily_kid_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام خانوادگی لاتین" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["lfamily_kid_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_kid_" + index]}
                              type="text"
                              id={"nationalCode_kid_" + index}
                              name={"nationalCode_kid_" + index}
                              value={this.state["nationalCode_kid_" + index]}
                              placeholder={this.state.isMobile ? "کد ملی" : ""}
                              onChange={(event) => {
                                this.setState({
                                  ["nationalCode_kid_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <DatePicker
                              onChange={(value) =>
                                this.setState({
                                  ["birthDate_kid_" + index]: value,
                                })
                              }
                              value={this.state["birthDate_kid_" + index]}
                              disabled={this.state["disabled_kid_" + index]}
                              isGregorian={true}
                              timePicker={false}
                              placeholder="تاریخ تولد"
                              persianDigits={false}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_kid_" + index]}
                              type="text"
                              id={"passportNum_kid_" + index}
                              name={"passportNum_kid_" + index}
                              value={this.state["passportNum_kid_" + index]}
                              placeholder={
                                this.state.isMobile ? "شماره گذرنامه" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["passportNum_kid_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_kid_" + index]}
                              type="text"
                              id={"passportDate_kid_" + index}
                              name={"passportDate_kid_" + index}
                              value={this.state["passportDate_kid_" + index]}
                              placeholder={
                                this.state.isMobile ? "تاریخ انقضا گذرنامه" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["passportDate_kid_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>

                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div
                            style={{
                              textAlign: "right",
                              display: "flex",
                              height: "100%",
                              marginTop: 10,
                              maxWidth: 350,
                            }}
                          >
                            <i
                              className="fa fa-ban"
                              style={{ cursor: "pointer", color: "red" }}
                              aria-hidden="true"
                              onClick={(event) => {
                                if (
                                  !this.state.permition.some((item) => {
                                    return item == 2;
                                  })
                                ) {
                                  this.toast.current.show({
                                    severity: "warn",
                                    summary: (
                                      <div>شما دسترسی حذف مسافر را ندارید</div>
                                    ),
                                    life: 8000,
                                  });
                                  return;
                                }
                                const p = {};
                                p["disabled_kid_" + index] =
                                  !this.state["disabled_kid_" + index];
                                this.setState({
                                  ...p,
                                });
                              }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {Array.from(
                    Array(parseInt(this.state.CountArr.baby)).keys()
                  ).map((item, index) => {
                    return (
                      <div
                        style={{
                          alignItems: "baseline",
                          display: "flex",
                          flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                        }}
                        className="mt-2 p-message p-message-warn "
                      >
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_baby_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام فارسی" : ""
                              }
                              type="text"
                              id={"name_baby_" + index}
                              name={"name_baby_" + index}
                              value={this.state["name_baby_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["name_baby_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_baby_" + index]}
                              type="text"
                              id={"family_baby_" + index}
                              name={"family_baby_" + index}
                              value={this.state["family_baby_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام خانوادگی فارسی" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["family_baby_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_baby_" + index]}
                              type="text"
                              id={"lname_baby_" + index}
                              name={"lname_baby_" + index}
                              value={this.state["lname_baby_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام لاتین" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["lname_baby_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_baby_" + index]}
                              type="text"
                              id={"lfamily_baby_" + index}
                              name={"lfamily_baby_" + index}
                              value={this.state["lfamily_baby_" + index]}
                              placeholder={
                                this.state.isMobile ? "نام خانوادگی لاتین" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["lfamily_baby_" + index]: event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_baby_" + index]}
                              type="text"
                              id={"nationalCode_baby_" + index}
                              name={"nationalCode_baby_" + index}
                              placeholder={this.state.isMobile ? "کد ملی" : ""}
                              value={this.state["nationalCode_baby_" + index]}
                              onChange={(event) => {
                                this.setState({
                                  ["nationalCode_baby_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <DatePicker
                              onChange={(value) =>
                                this.setState({
                                  ["birthDate_baby_" + index]: value,
                                })
                              }
                              value={this.state["birthDate_baby_" + index]}
                              disabled={this.state["disabled_baby_" + index]}
                              isGregorian={true}
                              timePicker={false}
                              placeholder="تاریخ تولد"
                              persianDigits={false}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_baby_" + index]}
                              type="text"
                              id={"passportNum_baby_" + index}
                              name={"passportNum_baby_" + index}
                              value={this.state["passportNum_baby_" + index]}
                              placeholder={
                                this.state.isMobile ? "شماره گذرنامه" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["passportNum_baby_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>
                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div style={{ textAlign: "right" }}>
                            <input
                              className="form-control yekan"
                              autoComplete="off"
                              disabled={this.state["disabled_baby_" + index]}
                              type="text"
                              id={"passportDate_baby_" + index}
                              name={"passportDate_baby_" + index}
                              value={this.state["passportDate_baby_" + index]}
                              placeholder={
                                this.state.isMobile ? "تاریخ انقضا گذرنامه" : ""
                              }
                              onChange={(event) => {
                                this.setState({
                                  ["passportDate_baby_" + index]:
                                    event.target.value,
                                });
                              }}
                              required="true"
                              style={{ maxWidth: 350 }}
                            />
                          </div>
                        </div>

                        <div style={{ width: 150, marginLeft: 8 }}>
                          <div
                            style={{
                              textAlign: "right",
                              display: "flex",
                              height: "100%",
                              marginTop: 10,
                              maxWidth: 350,
                            }}
                          >
                            <i
                              className="fa fa-ban"
                              style={{ cursor: "pointer", color: "red" }}
                              aria-hidden="true"
                              onClick={(event) => {
                                if (
                                  !this.state.permition.some((item) => {
                                    return item == 2;
                                  })
                                ) {
                                  this.toast.current.show({
                                    severity: "warn",
                                    summary: (
                                      <div>شما دسترسی حذف مسافر را ندارید</div>
                                    ),
                                    life: 8000,
                                  });
                                  return;
                                }
                                const p = {};
                                p["disabled_baby_" + index] =
                                  !this.state["disabled_baby_" + index];
                                this.setState({
                                  ...p,
                                });
                              }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Card>
                <Card
                  className="mt-3"
                  style={{ width: "90%" }}
                  title="اطلاعات کلی"
                  subTitle=""
                >
                  <div className="row">
                    <div className="col-lg-3 col-12">
                      <div className="group" style={{ textAlign: "right" }}>
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          type="text"
                          value={this.state.mobile}
                          name="name"
                          onChange={(event) => {
                            this.setState({ mobile: event.target.value });
                          }}
                          required="true"
                          style={{ maxWidth: 350 }}
                        />
                        <label>تلفن همراه سرپرست</label>
                      </div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div className="group">
                        <textarea
                          className="form-control irsans"
                          autoComplete="off"
                          type="text"
                          value={this.state.desc}
                          name="desc"
                          onChange={(event) =>
                            this.setState({ desc: event.target.value })
                          }
                        />
                        <label>توضیحات</label>
                      </div>
                    </div>
                    <div className="col-lg-12 mt-3 mb-3">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          flexDirection:'column'
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Checkbox
                            onChange={(e) =>
                              this.setState({ payed: e.checked })
                            }
                            checked={this.state.payed}
                          ></Checkbox>
                          <label style={{ paddingRight: 5, marginTop: 5 }}>
                            تسویه شده
                          </label>
                        </div>
                        {this.state.payed && (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                            className="mr-2"
                          >
                            <SelectButton
                              value={this.state.typeOfPayment}
                              style={{ direction: "ltr" }}
                              options={[
                                {
                                  label: "نقدی",
                                  value: "cash",
                                },
                                {
                                  label: "قسطی",
                                  value: "installment",
                                },
                              ]}
                              onChange={(e) => {
                                this.setState({
                                  typeOfPayment:
                                    e.value === null
                                      ? this.state.typeOfPayment
                                      : e.value,
                                });
                              }}
                            ></SelectButton>
                          </div>
                        )}
                        {this.state.typeOfPayment == "installment" &&
                          this.state.payed && (
                            <div
                              style={{
                                display: "flex",
                                width: 300,
                                justifyContent: "space-around",
                              }}
                            >
                              <div style={{ width: 120, marginLeft: 8 }}>
                                <div style={{ textAlign: "right" }}>
                                  <input
                                    className="form-control yekan"
                                    autoComplete="off"
                                    placeholder="پیش پرداخت"
                                    type="text"
                                    id="prePay"
                                    name="prePay"
                                    value={this.state.prePay}
                                    onChange={(event) => {
                                      this.setState({
                                        prePay: event.target.value
                                          .toString()
                                          .replace(/,/g, "")
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ),
                                      });
                                    }}
                                    style={{ maxWidth: 350 }}
                                  />
                                </div>
                              </div>
                              <div style={{ width: 120, marginLeft: 8 }}>
                                <div style={{ textAlign: "right" }}>
                                  <input
                                    className="form-control yekan"
                                    autoComplete="off"
                                    type="text"
                                    id="installmentPay"
                                    name="installmentPay"
                                    placeholder="مبلغ اقساط"
                                    value={this.state.installmentPay}
                                    onChange={(event) => {
                                      this.setState({
                                        installmentPay: event.target.value
                                          .toString()
                                          .replace(/,/g, "")
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ),
                                      });
                                    }}
                                    style={{ maxWidth: 350 }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </Panel>

            <div className="row">
              {this.state.hotels &&
                Array.isArray(this.state.hotels) &&
                this.state.hotels.map((h, i) => {
                  let sumOfBed = 0;
                  return (
                    <div className="col-lg-6 col-12">
                      <Panel
                        header={`مشخصات هتل ${h.name}`}
                        style={{ textAlign: "right", fontFamily: "yekan" }}
                        className="mt-2"
                        toggleable={true}
                        collapsed={true}
                        onExpand={() => {
                          this.getHotelReserved(h._id, this.state.groupId);
                        }}
                      >
                        <div
                          className="row p-message p-message-info"
                          style={{
                            alignItems: "baseline",
                            flexDirection: "column",
                            padding: 8,
                          }}
                        >
                          <div style={{ fontSize: 18 }}>{h.name}</div>
                          <div>
                            <span style={{ fontSize: 18 }}>{h.place}</span>
                          </div>
                          <div>
                            <span style={{ fontSize: 18 }}>
                              تعداد اتاقها :{" "}
                              {h.rooms.filter((item) => !item.deactive).length}
                            </span>
                          </div>
                        </div>
                        <div
                          className="row"
                          style={{
                            alignItems: "baseline",
                            display: this.state.isMobile ? "none" : "flex",
                          }}
                        >
                          <div
                            className="col-lg-1 col-12"
                            style={{ textAlign: "right" }}
                          ></div>
                          <div
                            className="col-lg-2 col-12"
                            style={{ textAlign: "right" }}
                          >
                            <span style={{ fontSize: 16 }}>شماره اتاق</span>
                          </div>
                          <div
                            className="col-lg-2 col-12"
                            style={{ textAlign: "right" }}
                          >
                            <span style={{ fontSize: 16 }}>تعداد تخت</span>
                          </div>
                          <div
                            className="col-lg-7 col-12"
                            style={{ textAlign: "right" }}
                          >
                            <span style={{ fontSize: 16 }}>توضیح</span>
                          </div>
                        </div>
                        {h.rooms &&
                          Array.isArray(h.rooms) &&
                          h.rooms.map((item, index) => {
                            if (!item.deactive) {
                              sumOfBed += item.numberOfBed;
                              return (
                                <div
                                  className="row"
                                  style={{
                                    alignItems: "center",
                                    backgroundColor:
                                      index % 2 ? "#eee" : "#ccc",
                                  }}
                                >
                                  <div className="col-lg-1 col-12">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Checkbox
                                        onChange={(e) => {
                                          let selectedRoom =
                                            this.state.selectedRoom;
                                          const state = { roomsChanged: true };
                                          if (e.checked) {
                                            selectedRoom.push({
                                              _id: item._id,
                                              traveler: this.state.travelerId,
                                              hotelId: h._id,
                                              changed: true,
                                            });
                                            state["selectedRoom"] =
                                              selectedRoom;
                                          } else {
                                            selectedRoom = selectedRoom.filter(
                                              (sss) => {
                                                return sss._id != item._id;
                                              }
                                            );
                                          }
                                          this.setState({
                                            selectedRoom: selectedRoom,
                                            roomsChanged: true,
                                          });
                                        }}
                                        disabled={
                                          this.state.selectedRoom.some(
                                            (iii) => {
                                              return (
                                                iii._id == item._id &&
                                                !iii.changed
                                              );
                                            }
                                          ) &&
                                          this.state.selectedRoom.some(
                                            (iii) => {
                                              return (
                                                (iii._id == item._id &&
                                                  iii.traveler !=
                                                    this.state.travelerId) ||
                                                (iii.traveler &&
                                                  !this.state.travelerId)
                                              );
                                            }
                                          )
                                        }
                                        checked={this.state.selectedRoom.some(
                                          (iii) => {
                                            return iii._id == item._id;
                                          }
                                        )}
                                      ></Checkbox>
                                    </div>
                                  </div>
                                  <div
                                    className="col-lg-2 col-12"
                                    style={{ textAlign: "right", fontSize: 20 }}
                                  >
                                    <span
                                      style={{
                                        display: this.state.isMobile
                                          ? "inline"
                                          : "none",
                                      }}
                                    >
                                      شماره اتاق :{" "}
                                    </span>{" "}
                                    <span>{item.number}</span>
                                  </div>
                                  <div
                                    className="col-lg-2 col-12"
                                    style={{ textAlign: "right", fontSize: 20 }}
                                  >
                                    <span
                                      style={{
                                        display: this.state.isMobile
                                          ? "inline"
                                          : "none",
                                      }}
                                    >
                                      تعداد تخت :{" "}
                                    </span>{" "}
                                    <span>{item.numberOfBed}</span>
                                  </div>
                                  <div
                                    className="col-lg-7 col-12"
                                    style={{ textAlign: "right", fontSize: 20 }}
                                  >
                                    <span
                                      style={{
                                        display: this.state.isMobile
                                          ? "inline"
                                          : "none",
                                      }}
                                    >
                                      توضیح:{" "}
                                    </span>{" "}
                                    <span>{item.desc}</span>
                                  </div>
                                </div>
                              );
                            }
                          })}

                        <div>
                          <span style={{ fontWeight: "bold" }}>
                            تعداد تختها : {sumOfBed}
                          </span>
                        </div>
                      </Panel>
                    </div>
                  );
                })}
            </div>

            <div className="row">
              <div
                className="col-lg-2  col-12 mb-3"
                style={{ textAlign: "right" }}
              >
                <button
                  className="btn btn-success irsans"
                  loading={this.state.loading}
                  disabled={this.state.loading || !this.state.allowEdit}
                  type="submit"
                  style={{
                    width: "200px",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  {this.state.travelerId ? "اصلاح" : "ثبت"}
                </button>
              </div>
              <div
                className="col-lg-3 col-12 mb-3"
                style={{ textAlign: "right" }}
              >
                <button
                  className="btn btn-info irsans"
                  loading={this.state.loading}
                  disabled={this.state.loading}
                  onClick={(event) => {
                    this.resetForm();
                    event.stopPropagation();
                  }}
                  style={{
                    width: "200px",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  مسافر جدید
                </button>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Travel_Set);
